import { render, staticRenderFns } from "./kaoshi2.vue?vue&type=template&id=9181a95c&scoped=true&"
import script from "./kaoshi2.vue?vue&type=script&lang=js&"
export * from "./kaoshi2.vue?vue&type=script&lang=js&"
import style0 from "./kaoshi2.vue?vue&type=style&index=0&id=9181a95c&prod&lang=scss&scoped=true&"
import style1 from "./kaoshi2.vue?vue&type=style&index=1&id=9181a95c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9181a95c",
  null
  
)

export default component.exports